import { LOBState } from "stores/wizard/state";
import { CruiseConfig } from "stores/wizard/config";

export class CruiseWizardState implements Pick<LOBState, "config"> {
  public config: CruiseConfig;

  constructor(config: CruiseConfig) {
    this.config = config;
  }
}
